/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMultipleSelectionValueErrorMessage } from './formPagePropertyItemMultipleSelectionValueErrorMessage';


/**
 * 選択した選択肢番号
 */
export interface FormPagePropertyItemMultipleSelectionPropertyItemValue { 
    type: FormPagePropertyItemMultipleSelectionPropertyItemValue.TypeEnum;
    enum: Array<number>;
    errorMessage: FormPagePropertyItemMultipleSelectionValueErrorMessage;
}
export namespace FormPagePropertyItemMultipleSelectionPropertyItemValue {
    export type TypeEnum = 'integer';
    export const TypeEnum = {
        Integer: 'integer' as TypeEnum
    };
}



